import { render, staticRenderFns } from "./oficiovaga.vue?vue&type=template&id=fd24e752&"
import script from "./oficiovaga.vue?vue&type=script&lang=js&"
export * from "./oficiovaga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports